import { Box, Typography, Grid, Paper, Avatar, CircularProgress, IconButton, Tooltip } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import SyncIcon from '@mui/icons-material/Sync';
import { useLanguage } from '../../../utils/i18n';

export default function VehicleRitase({ data, loading, onRefresh }) {
  const { t } = useLanguage();
  const stats = [
    { title: t('revenue.totalVehicle', 'Total Vehicle'), value: data?.totalVehicles || 0 },
    { title: t('revenue.totalRetase', 'Total Retase'), value: data?.totalRitase || 0 },
    { title: t('avgRetase', 'Average Ritase/Day'), value: data?.avgRitasePerDay || 0 }
  ];

  return (
    <Paper
      elevation={0}
      variant="outlined"
      sx={{ p: 2.5, borderRadius: 2, bgcolor: '#f8fafc', border: '1px solid #e2e8f0', height: '100%' }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              bgcolor: '#4c5c96',
              color: 'white',
              borderRadius: 1.5,
              width: 32,
              height: 32,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <TrendingUpIcon fontSize="small" />
          </Box>
          <Typography variant="h4" fontWeight="bold">
            {t('revenue.vehicleRetase', 'Vehicle Retase')}
          </Typography>
        </Box>

        <Tooltip title={t('refresh', 'Refresh Data')}>
          <span>
            <IconButton
              onClick={onRefresh}
              disabled={loading}
              sx={{
                bgcolor: 'white',
                border: '1px solid #e2e8f0',
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                color: '#475569',
                '&:hover': {
                  bgcolor: '#f1f5f9',
                  color: '#3b82f6',
                  borderColor: '#cbd5e1'
                },
                transition: 'all 0.2s ease',
                ...(loading && {
                  animation: 'spin 1s linear infinite',
                  '@keyframes spin': {
                    '0%': { transform: 'rotate(0deg)' },
                    '100%': { transform: 'rotate(360deg)' }
                  }
                })
              }}
              size="small"
            >
              <SyncIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      </Box>

      <Grid container spacing={2}>
        {stats.map((stat, index) => (
          <Grid item size={{ xs: 12, sm: 6, md: 4 }} key={index}>
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderRadius: 2,
                borderWidth: 2,
                boxShadow: 2
              }}
            >
              <Box>
                <Typography variant="h5" fontWeight={600} color="text.primary" sx={{ display: 'block', mb: 0.5 }}>
                  {stat.title}
                </Typography>
                <Typography variant="h4" fontWeight="bold" color="text.primary" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {loading ? <CircularProgress size={24} color="inherit" /> : stat.value}
                </Typography>
              </Box>
              <Avatar sx={{ bgcolor: '#1976d2', color: 'white', width: 40, height: 40 }}>
                <DirectionsCarIcon />
              </Avatar>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}
